import { FC } from 'react';

import { Icon, RyeconWarningOutline } from '@dbt-labs/sourdough';

export const AssetDoesNotExist: FC = () => {
  return (
    <div className="mx-auto w-6/12" data-testid="asset-does-not-exist">
      <div className="mt-[30%] text-center">
        <div className={`m-auto flex h-[56px] w-[56px] rounded-md`}>
          <Icon size="lg" ryecon={RyeconWarningOutline} />
        </div>
        <div className="mt-4 break-words">
          <h1 className="mb-2 text-2xl font-medium">
            We couldn't find this asset in your account.
          </h1>
          <span className="text-base font-normal">
            It may have been deleted or is no longer included in the latest sync. Please
            check the URL or contact your admin to refresh metadata if needed.
          </span>
        </div>
      </div>
    </div>
  );
};
